import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CommonModule, NgClass, NgForOf, NgIf} from '@angular/common';
import {FormElementComponent} from '../../../shared/forms/form-element/form-element.component';
import {Button, ButtonDirective} from 'primeng/button';
import {FormTypes} from '../../../shared/forms/models/constants';
import {EvidenceSvgPipe} from "../../../shared/pipes/evidence-svg.pipe";
import {PlanType, Subscriptions} from "../../model/subscriptions.models";
import {Router} from "@angular/router";
import {SignatureLevel} from "../../model/signer-model";
import {SubscriptionsService} from "../../services/subscriptions.service";
import {SubscriptionInfo} from "../../model/subscription-nfo";

@Component({
    selector: 'app-add-signers',
    standalone: true,
    imports: [
        CommonModule,
        TranslatePipe,
        InputSwitchModule,
        NgForOf,
        NgIf,
        FormElementComponent,
        NgClass,
        Button,
        ReactiveFormsModule,
        EvidenceSvgPipe,
        ButtonDirective,
    ],
    templateUrl: './add-signers.component.html',
    styleUrl: './add-signers.component.scss'
})
export class AddSignersComponent implements OnInit, OnChanges {
    protected readonly FormTypes = FormTypes;

    @Input() signersForm!: FormGroup;
    @Input() isCloseTriggered!: boolean;
    @Input() userSubscription!: Subscriptions;
    @Output() signersEmitter: EventEmitter<any> = new EventEmitter();
    @Output() requiredEmitter: EventEmitter<any> = new EventEmitter();
    usageLimit!: number;
    isLimitExceeded: boolean = false;
    inclusiveSignsExceeded: boolean = false;
    subscriptionInfo!: SubscriptionInfo;
    isTotalAllowedSignerFull: boolean = false;
    isSigningTypeCannotBeSelectedOpen = false;
    totalSigners = 0;
    selectedLegalWeight = SignatureLevel.BASIC;

    isOnlyOwnSign: boolean = false;

    countFesQesSigns: number = 0;


    constructor(private fb: FormBuilder,
                private router: Router,
                private subscriptionService: SubscriptionsService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.signersForm) {
            this.updateSigningControlState();
        }
        if (changes['isCloseTriggered']) {
            this.setTheSigners();
        }

        if (changes['userSubscription']) {
            const currentLegalWeight = this.signersForm.get('legalweight')?.value;
            if (this.userSubscription?.plan === PlanType.STARTER) {
                this.controlLegalWeight(PlanType.BASIC, false)
            } else if (this.userSubscription?.plan === PlanType.BASIC && (currentLegalWeight === SignatureLevel.HIGH || currentLegalWeight === SignatureLevel.MAX)) {
                this.controlLegalWeight(SignatureLevel.BASICCERT, false)
            }
            this.calculateUsageLimit();
        }
        this.setLimitOwnSign();

    }

    ngOnInit() {
        const tmp = this.signersForm.get('legalweight')?.value as string;
        if (tmp) {
            this.signersForm.get('legalweight')?.setValue(tmp.toLowerCase());
        }

        this.setLimitOwnSign();
        this.getSubscriptionInfo();
    }


    async getSubscriptionInfo() {
        try {
            const info: SubscriptionInfo = await this.subscriptionService.getSubscriptionInfo();
            this.subscriptionInfo = info;
            this.countFesQesSigns = 0;
            this.inclusiveSignsExceeded = false;
            if (this.selectedLegalWeight === SignatureLevel.HIGH) {
                this.inclusiveSignsExceeded = info.inclusiveSignsExceeded;
                this.countFesQesSigns = info.fesCount;
            } else if (this.selectedLegalWeight === SignatureLevel.MAX) {
                this.countFesQesSigns = info.qesCount;
                this.inclusiveSignsExceeded = info.inclusiveSignsExceeded;
            } else if (this.selectedLegalWeight === SignatureLevel.BASICCERT) {
            }

            //this.usageLimit = info.credit;
        } catch (error) {
            console.error('API error:', error);
        }
    }

    setLimitOwnSign() {
        const plan: boolean = [PlanType.BASIC, PlanType.BUSINESS].includes(this.userSubscription?.plan as PlanType);
        const selecteLevel = [SignatureLevel.MAX, SignatureLevel.HIGH].includes(this.selectedLegalWeight as SignatureLevel);

        //ToDo: Limit OnlyOwn Sign  for testing
        //this.isOnlyOwnSign = plan && selecteLevel;
        //this.isOnlyOwnSign = true;
        if (this.isOnlyOwnSign) {
            this.clearTheSigners();
        }
    }

    private createSignerGroup(): FormGroup {
        return this.fb.group({
            fullName: [''],
            email: ['']
        });
    }

    changeEvent() {
        if (this.totalSigners >= 5 && this.signersForm.get('iamsigning')?.value) {
            this.isTotalAllowedSignerFull = true;
            setTimeout(() => {
                this.isTotalAllowedSignerFull = false;
            }, 2500)
        }
        this.calculateTotalSigners();
    }

    get signerControls(): FormGroup[] {
        return (this.signersForm.get('signers') as FormArray).controls as FormGroup[];
    }

    returnSelfSignInputSwitchDisableProperty(): boolean {
        return (this.totalSigners === this.usageLimit || this.totalSigners >= 5) && !this.signersForm.get('iamsigning')?.value;
    }


    private updateSigningControlState(): void {
        const control = this.signersForm.get('iamsigning');
        const shouldDisable = this.returnSelfSignInputSwitchDisableProperty();

        if (shouldDisable && control?.enabled) {
            control.disable({emitEvent: false});
        } else if (!shouldDisable && control?.disabled) {
            control.enable({emitEvent: false});
        }
    }

    calculateTotalSigners() {
        const arrayLength: number = this.signersForm.get('signers')?.value.length;
        const selfSignCount = this.signersForm.get('iamsigning')?.value ? 1 : 0;

        this.totalSigners = arrayLength + selfSignCount;
    }

    addSigner(): void {

        const signType = this.signersForm.get('legalweight')?.value;

        if (this.totalSigners < 5) {
            if (signType === SignatureLevel.HIGH
                || signType === SignatureLevel.MAX) {
                if (this.totalSigners < this.usageLimit) {

                    this.isLimitExceeded = false;
                    (this.signersForm.get('signers') as FormArray).push(this.createSignerGroup());

                } else {
                    this.isLimitExceeded = true;
                }
            } else {
                (this.signersForm.get('signers') as FormArray).push(this.createSignerGroup());
            }
        } else {
            this.isTotalAllowedSignerFull = true;
            setTimeout(() => {
                this.isTotalAllowedSignerFull = false;
            }, 5000)
        }

        this.calculateTotalSigners();
    }

    removeFormArray(index: number) {
        const control = this.signersForm.get('signers') as FormArray;
        control.removeAt(index);
    }

    dropEmail(index: number): void {
        // const control = this.signersForm.get('signers') as FormArray;
        // control.removeAt(index);

        this.removeFormArray(index);
        this.isTotalAllowedSignerFull = false;
        this.isLimitExceeded = false;
        this.calculateTotalSigners();
    }

    setTheSigners(): void {

        // ToDo: bu ne yapiyor? neden? silinebilirmi?
        // let signers = this.signerControls.map((group, index) => ({
        //     index,
        //     emailField: `email${index}`,
        //     nameField: `name${index}`,
        //     email: group.get('email')?.value,
        //     fullName: group.get('fullName')?.value
        // }));

        const signersArray = this.signersForm.get('signers') as FormArray;

        // remove formArray element if email isnt set.
        // rückwärts iterieren, damit der Index beim Entfernen korrekt bleibt
        for (let i = signersArray.length - 1; i >= 0; i--) {
            const signerGroup = signersArray.at(i) as FormGroup;
            const emailCtrl = signerGroup.get('email');

            if (!emailCtrl || emailCtrl.value === '') {
                signersArray.removeAt(i);
            }
        }
        this.requiredEmitter.emit(this.isSigningTypeCannotBeSelectedOpen);
        this.signersEmitter.emit(this.signersForm);
    }

    clearTheSigners() {

        const signersArray = this.signersForm.get('signers') as FormArray;
        for (let i = 0; i <= signersArray.length; i++) {

            this.removeFormArray(i);
        }
        this.dropEmail(0);

    }

    controlLegalWeight(legalweight: any, isDisabled: boolean) {
        if (isDisabled) {
            this.isSigningTypeCannotBeSelectedOpen = true;
            this.signersForm.get('legalweight')?.setValue(null);

            setTimeout(() => {
                this.isSigningTypeCannotBeSelectedOpen = false;
            }, 5000);


        } else {
            this.signersForm.get('legalweight')?.setValue(legalweight);
            this.getSubscriptionInfo();
            this.signersEmitter.emit(this.signersForm);
            this.calculateUsageLimit();
            this.setLimitOwnSign();
        }
    }

    // Todo: move amounts to enviroment...
    calculateUsageLimit() {
        this.selectedLegalWeight = this.signersForm.get('legalweight')?.value;
        this.isSigningTypeCannotBeSelectedOpen = false;
        const selectedPlanType = this.userSubscription?.plan as PlanType;
        if (this.selectedLegalWeight === SignatureLevel.BASICCERT && selectedPlanType === (PlanType.STARTER).toLowerCase()) {
            this.isSigningTypeCannotBeSelectedOpen = true;
        } else if (this.selectedLegalWeight === SignatureLevel.HIGH) {
            // ToDo: this.userSubscription.details[2] wrong...
            this.usageLimit = Math.floor(this.userSubscription.credit / 1.8) + this.userSubscription.details[2]?.signLimit;
        } else if (this.selectedLegalWeight === SignatureLevel.MAX) {
            // ToDo: this.userSubscription.details[2] wrong...
            this.usageLimit = Math.floor(this.userSubscription.credit / 3.8) + this.userSubscription.details[2]?.signLimit;
        }

        if (this.isSigningTypeCannotBeSelectedOpen) {
            this.signersForm.get('legalweight')?.setValue(null);
        }
    }

    navigateToPaymentPage(pt: 'subscriptionPayment' | 'creditPayment', isAutoRouted: boolean): void {
        this.router.navigate(['/payment'], {
            queryParams: {purchaseType: pt, isAutoRouted: isAutoRouted}
        });
        setTimeout(() => {
            this.signersEmitter.emit('close')
        })
    }

    ngOnDestroy(): void {
        this.setTheSigners();
    }

    protected readonly PlanType = PlanType;
}
